import { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface HelpContextType {
  helpEnabled: boolean;
  toggleHelp: () => void;
}

const HelpContext = createContext<HelpContextType>({
  helpEnabled: true,
  toggleHelp: () => {},
});

export const useHelp = () => useContext(HelpContext);

export const HelpProvider = ({ children }: { children: ReactNode }) => {
  const [helpEnabled, setHelpEnabled] = useState(() => {
    const stored = localStorage.getItem("helpEnabled");
    return stored !== null ? stored === "true" : true;
  });

  useEffect(() => {
    localStorage.setItem("helpEnabled", String(helpEnabled));
  }, [helpEnabled]);

  const toggleHelp = () => setHelpEnabled((prev) => !prev);

  return (
    <HelpContext.Provider value={{ helpEnabled, toggleHelp }}>
      {children}
    </HelpContext.Provider>
  );
};
